import { useRouteError, Link } from "react-router-dom";
import { Button } from "@racoon/ui";
import { Home, AlertCircle } from "lucide-react";

export default function ErrorPage() {
  const error = useRouteError() as any;

  return (
    <div className="px-4 min-h-dvh flex items-center justify-center p-6">
      <div className="text-center space-y-6 max-w-md">
        <div className="flex justify-center">
          <AlertCircle className="h-16 w-16 text-red-500" />
        </div>

        <div className="space-y-2">
          <h1 className="text-2xl font-bold text-slate-900 dark:text-slate-100">
            Oops! Something went wrong
          </h1>
          <p className="text-slate-600 dark:text-slate-400">
            {error?.statusText || error?.message || "An unexpected error occurred"}
          </p>
        </div>

        <div className="space-y-4">
          <Button asChild>
            <Link to="/">
              <Home className="h-4 w-4 mr-2" />
              Go Home
            </Link>
          </Button>

          <div>
            <Button variant="outline" onClick={() => window.location.reload()}>
              Try Again
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
